import { render, staticRenderFns } from "./bh-flow-holder.vue?vue&type=template&id=fd21f3bc&scoped=true&lang=pug"
import script from "./bh-flow-holder.vue?vue&type=script&lang=ts"
export * from "./bh-flow-holder.vue?vue&type=script&lang=ts"
import style0 from "./bh-flow-holder.vue?vue&type=style&index=0&id=fd21f3bc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd21f3bc",
  null
  
)

export default component.exports